import {useEffect} from "react"
import {useNavigate} from "react-router-dom"
import SigninForm from "../forms/authentification/SigninForm"
import {useSessionContext} from "../reactContext/contextCustomHooks/useSessionContext"

export default function Signin() {
    const {sessionContext} = useSessionContext()
    let navigate = useNavigate()

    useEffect(() => {
        sessionContext.isLogin && navigate("/")
    }, [])

    return (
        <>
        <div className="VIEW SIGNIN">
            <SigninForm/>
        </div>
        </>
    )
}